import {
  Component,
  OnInit,
} from '@angular/core';
import { Location } from "@angular/common";
import { AppState } from '../../../../app.reducer';
import { Store } from '@ngrx/store';
import { GetMyDocuments } from "../_store/resources.actions";
import { debounceTime } from "rxjs/operators";
import { FormControl } from "@angular/forms";
import { filterResults } from "../../../../app.constants";

@Component({
  selector: 'existing-documents',
  templateUrl: './existing-documents.component.html',
  styleUrls: ['./existing-documents.component.scss']
})
export class ExistingDocumentComponent implements OnInit {
  documentList;
  filteredDocuments;
  searchInput = new FormControl();
  myFilesPageNumber: number =1;
  myFilesPages: number =0;

  constructor(
    private store: Store<AppState>,
    public location: Location,
  ) { }

  ngOnInit() {
    this.store.dispatch(new GetMyDocuments({'page': this.myFilesPageNumber, "limit": 30}));
    this.store.select(state => state.resources.myDocuments).subscribe(docList => {
      this.documentList = docList;
      this.filteredDocuments = docList;
    });

    /* listening to search input */
    this.searchInput.valueChanges.pipe(debounceTime(1000)).subscribe(searchString => {
      this.filteredDocuments = filterResults(this.documentList, searchString);
    });
  }
}
